module.exports = file => () => import('@/views/' + file);



// WEBPACK FOOTER //
// ./src/libs/util.import.production.js